import { defineStore } from "pinia";

export const caseProcessingStore = defineStore('case-processing', {
  actions: {
    async getChangeSummaryCount(postId) {
      return await this.$wp.caseProcessing.read(postId, 'changes/count');
    }
  }
}); 